// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__A6Een","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2PSzs"};